/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class KeyValuePairKind extends models.KeyValuePair {
    getFixupPrototypeFunction() { return KeyValuePairKind.fixupPrototype; }

    static newInstance(model: Partial<KeyValuePairKind>): KeyValuePairKind {
        let obj = Object.assign(new KeyValuePairKind(), model);
        KeyValuePairKind.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<KeyValuePairKind>): KeyValuePairKind {
        if (!model) return null;
        return KeyValuePairKind.newInstance(<KeyValuePairKind> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: KeyValuePairKind) {
        if (!obj) return;

        models.KeyValuePairKind.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: KeyValuePairKind): boolean {
        if (models.KeyValuePair.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, KeyValuePairKind.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Type of the key
     */
    kind: string;

}
